import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 用户&学生部分
 *
 */

/**
 * 已购课程：列表
 * @param {*} query
 */
export const courseList = (query) => {
  return request({
    url: `${prefix}/member/course/list`,
    method: 'get',
    params: query
  })
}

/**
 * 已购课程：x修改
 * @param {*} query
 */
export const memberCourse = (query) => {
  return request({
    url: `${prefix}/member/course`,
    method: 'PUT',
    data: query
  })
}
/**
 * 已购课程：x修改
 * @param {*} query
 */
export const memberRead = (query) => {
  return request({
    url: `${prefix}/member/read`,
    method: 'PUT',
    data: query
  })
}

// 
/**
 * 已购专栏：列表
 * @param {*} query
 */
export const readList = (query) => {
  return request({
    url: `${prefix}/member/read/list`,
    method: 'get',
    params: query
  })
}


// /member/course/list
/**
 * 用户查询：列表
 * @param {*} query
 */
export const memberList = (query) => {
  return request({
    url: `${prefix}/member/list`,
    method: 'get',
    params: query
  })
}

/**
 * 用户查询：列表导出
 * @param {*} query
 */
export const memberExport = (query) => {
  return request({
    url: `${prefix}/member/list/export`,
    method: 'get',
    params: query
  })
}

/**
 * 用户查询
 * @param {*} query
 */
export const memberOne = (query) => {
  return request({
    url: `${prefix}/member`,
    method: 'get',
    params: query
  })
}

/**
 * 用户创建
 * @param {*} query
 */
export const memberCreate = (query) => {
  return request({
    url: `${prefix}/member`,
    method: 'post',
    data: query
  })
}

/**
 * 机构用户查询：列表
 * @param {*} query
 */
export const crmCompanyUserList = (query) => {
  return request({
    url: `${prefix}/crm/company/user/list`,
    method: 'get',
    params: query
  })
}

/**
 * 用户批量创建
 * @param {*} query
 */
export const memberBulkCreate = (query) => {
  return request({
    url: `${prefix}/member/tool/createUser/bulk`,
    method: 'post',
    data: query
  })
}

/**
 * 用户修改
 * @param {*} query
 */
export const memberUpdate = (query) => {
  return request({
    url: `${prefix}/member`,
    method: 'put',
    data: query
  })
}
/**
 * 报考信息
 * @param {*} query
 */
export const memberApplicant = (query) => {
  return request({
    url: `${prefix}/member/applicant`,
    method: 'get',
    params: query
  })
}
/**
 * 修改报考信息
 * @param {*} query
 */
export const memberApplicantPut = (query) => {
  return request({
    url: `${prefix}/member/applicant`,
    method: 'POST',
    data: query
  })
}




/**
 * 查询科目信息
 * @param {*} query
 */
export const subjectlicant = (query) => {
  return request({
    url: `${prefix}/member/subject/list`,
    method: 'get',
    params: query
  })
}







/**
 * 用户删除
 * @param {*} query
 */
export const memberDestroy = (query) => {
  return request({
    url: `${prefix}/member`,
    method: 'delete',
    data: query
  })
}

/**
 * 用户注销
 * @param {*} query
 */
export const memberDELETE= (query) => {
  return request({
    url: `${prefix}/member`,
    method: 'delete',
    data: query
  })
}


/**
 * 用户删除：列表
 * @param {*} query
 */
export const memberRemoves = (query) => {
  return request({
    url: `${prefix}/member/list`,
    method: 'delete',
    data: query
  })
}


/**
 * 用户订单查询：列表
 * @param {*} query
 */
export const memberOrderList = (query) => {
  return request({
    url: `${prefix}/member/order/list`,
    method: 'get',
    params: query
  })
}

/**
 * 用户订单查询
 * @param {*} query
 */
export const memberOrderOne = (query) => {
  return request({
    url: `${prefix}/member/order`,
    method: 'get',
    params: query
  })
}

/**
 * 订单查询：列表导出
 * @param {*} query
 */
export const memberOrderExport = (query) => {
  return request({
    url: `${prefix}/member/order/list/export`,
    method: 'get',
    params: query
  })
}

/**
 * 用户订单查询 快递信息
 * @param {*} query
 */
export const memberOrderExpress = (query) => {
  return request({
    url: `${prefix}/member/order/express`,
    method: 'get',
    params: query
  })
}

/**
 * 用户订单创建
 * @param {*} query
 */
export const memberOrderCreate = (query) => {
  return request({
    url: `${prefix}/member/order`,
    method: 'post',
    data: query
  })
}

/**
 * 用户订单创建 管理员创建
 * @param {*} query
 */
export const memberOrderBuild = (query) => {
  return request({
    url: `${prefix}/member/order/build`,
    method: 'post',
    data: query
  })
}

/**
 * 用户订单修改
 * @param {*} query
 */
export const memberOrderUpdate = (query) => {
  return request({
    url: `${prefix}/member/order`,
    method: 'put',
    data: query
  })
}
/**
 * 订单修改1v1信息接口
 * @param {*} query
 */

export const oneToOneInfoPut = (query) => {
  return request({
    url: `${prefix}/member/order/oneToOneInfo`,
    method: 'put',
    data: query
  })
}
/**
 *  答疑卡修改订单核销状态接口
 * @param {*} query
 */
export const answerCardInfo = (query) => {
  return request({
    url: `${prefix}/member/order/answerCardInfo`,
    method: 'put',
    data: query
  })
}



/**
 * 用户订单发货
 * @param {*} query
 */
export const memberOrderShipping = (query) => {
  return request({
    url: `${prefix}/member/order/shipping`,
    method: 'post',
    data: query
  })
}

/**
 * 用户订单删除
 * @param {*} query
 */
export const memberOrderDestroy = (query) => {
  return request({
    url: `${prefix}/member/order`,
    method: 'delete',
    data: query
  })
}

/**
 * 用户营收记录查询 列表分页
 * @param {*} query
 */
export const memberProfitLogs = (query) => {
  return request({
    url: `${prefix}/member/profit/logs`,
    method: 'get',
    params: query
  })
}

/**
 * 用户提现订单创建
 * @param {*} query
 */
export const memberWithdrawCreate = (query) => {
  return request({
    url: `${prefix}/member/withdraw/order`,
    method: 'post',
    data: query
  })
}

/**
 * 用户提现订单撤销
 * @param {*} query
 */
export const memberWithdrawRevoke = (query) => {
  return request({
    url: `${prefix}/member/withdraw/revoke`,
    method: 'post',
    data: query
  })
}

/**
 * 用户提现订单查询
 * @param {*} query
 */
export const memberWithdrawOne = (query) => {
  return request({
    url: `${prefix}/member/withdraw/order`,
    method: 'get',
    params: query
  })
}

/**
 * 用户提现订单查询 列表
 * @param {*} query
 */
export const memberWithdrawList = (query) => {
  return request({
    url: `${prefix}/member/withdraw/order/list`,
    method: 'get',
    params: query
  })
}

/**
 * 用户分组查询：列表
 * @param {*} query
 */
export const memberCategoryList = (query) => {
  return request({
    url: `${prefix}/member/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 用户分组查询
 * @param {*} query
 */
export const memberCategoryOne = (query) => {
  return request({
    url: `${prefix}/member/category`,
    method: 'get',
    params: query
  })
}

/**
 * 用户分组创建
 * @param {*} query
 */
export const memberCategoryCreate = (query) => {
  return request({
    url: `${prefix}/member/category`,
    method: 'post',
    data: query
  })
}

/**
 * 用户分组修改
 * @param {*} query
 */
export const memberCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/member/category`,
    method: 'put',
    data: query
  })
}

/**
 * 用户分组删除
 * @param {*} query
 */
export const memberCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/member/category`,
    method: 'delete',
    data: query
  })
}

/**
 * 管理员订单查询：列表
 * @param {*} query
 */
export const adminOrderList = (query) => {
  return request({
    url: `${prefix}/member/order/build/list`,
    method: 'get',
    params: query
  })
}

/**
 * 管理员订单删除
 * @param {*} query
 */
export const deleteAdminOrderList = (query) => {
  return request({
    url: `${prefix}/member/order/build`,
    method: 'delete',
    data: query
  })
}


/**
 * 订单（手动退款）
 * @param {*} query
 */
export const orderrefund = (query) => {
  return request({
    url: `${prefix}/member/order/refund`,
    method: 'post',
    data: query
  })
}


/**
 * 管理员创建订单（创建多个)
 * @param {*} query
 */
export const buildmulti = (query) => {
  return request({
    url: `${prefix}/member/order/build/multi`,
    method: 'post',
    data: query
  })
}




/**
 * 微信支付（请求分账完结）
 * @param {*} query
 */
export const profitSharingFinish = (query) => {
  return request({
    url: `${prefix}/pay/wechatPay/profitSharingFinish`,
    method: 'post',
    data: query
  })
}


/**
 * 微信支付（查询分账订单待分账金额）
 * @param {*} query
 */
export const profitSharingAmountQuery = (query) => {
  return request({
    url: `${prefix}/pay/wechatPay/profitSharingAmountQuery`,
    method: 'get',
    params: query

  })
}

